import React, { useState } from "react";

import { DateRange, PartStatusDuration } from "../components";

import { PartStatusList } from "../../helpers/parts";

const PartStatus = () => {
  const [range, setRange] = useState(null);

  return (
    <div className="container has-background-light p-6 mt-5">
      <DateRange range={range} setRange={setRange} />

      <div className="columns is-multiline">
        {range
          ? PartStatusList.filter((p) => p.id < 70).map((status) => (
              <div className="column is-4" key={status.key}>
                <PartStatusDuration status={status} range={range} />
              </div>
            ))
          : null}
      </div>
    </div>
  );
};

export default PartStatus;
